module.exports = __webpack_public_path__ + "static/revanth_periyasamy-ad961c42288fb04b94e40738d6170c6a.png";